"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class ItemMetadata extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'itemMetadata';
        this._itemType = initParams.item_type;
        this._totalIssueCount = initParams.total_issue_count;
        this._deviceCount = initParams.device_count;
        this._deviceDisconnectedCount = initParams.device_disconnected_count;
        this._deviceIntermittentCount = initParams.device_intermittent_count;
        this._deviceLowSignalCount = initParams.device_low_signal_count;
        this._hubCount = initParams.hub_count;
        this._hubDisconnectedCount = initParams.hub_disconnected_count;
        this._hubIntermittentCount = initParams.hub_intermittent_count;
        this._hubLowSignalCount = initParams.hub_low_signal_count;
        this._sitesCount = initParams.sites_count;
    }
    set itemType(value) {
        console.error('Do not set objects this way');
    }
    get itemType() {
        return this._itemType;
    }
    set totalIssueCount(value) {
        console.error('Do not set objects this way');
    }
    get totalIssueCount() {
        return this._totalIssueCount;
    }
    set deviceCount(value) {
        console.error('Do not set objects this way');
    }
    get deviceCount() {
        return this._deviceCount;
    }
    set deviceDisconnectedCount(value) {
        console.error('Do not set objects this way');
    }
    get deviceDisconnectedCount() {
        return this._deviceDisconnectedCount;
    }
    set deviceIntermittentCount(value) {
        console.error('Do not set objects this way');
    }
    get deviceIntermittentCount() {
        return this._deviceIntermittentCount;
    }
    set deviceLowSignalCount(value) {
        console.error('Do not set objects this way');
    }
    get deviceLowSignalCount() {
        return this._deviceLowSignalCount;
    }
    set hubCount(value) {
        console.error('Do not set objects this way');
    }
    get hubCount() {
        return this._hubCount;
    }
    set hubDisconnectedCount(value) {
        console.error('Do not set objects this way');
    }
    get hubDisconnectedCount() {
        return this._hubDisconnectedCount;
    }
    set hubIntermittentCount(value) {
        console.error('Do not set objects this way');
    }
    get hubIntermittentCount() {
        return this._hubIntermittentCount;
    }
    set hubLowSignalCount(value) {
        console.error('Do not set objects this way');
    }
    get hubLowSignalCount() {
        return this._hubLowSignalCount;
    }
    set sitesCount(value) {
        console.error('Do not set objects this way');
    }
    get sitesCount() {
        return this._sitesCount;
    }
}
exports.default = ItemMetadata;
//# sourceMappingURL=itemMetadata.js.map